// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { HttpClientInstance } from "@toggl/sync/http";
import {
  CandidateauthAuthRequest,
  CandidateauthInitializeAuthUrl,
  CandidateauthMagicLinkRequest,
  CandidateauthTestLoginRequest,
  CandidateMeResponse,
  CandidateUpdateCandidateParams,
} from "../types";
import { buildSearchParams } from "../utils/requests";

export async function postMagicLink(
  httpClient: HttpClientInstance,
  data: CandidateauthMagicLinkRequest,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`auth/email`, { signal, json: data })
    .json<unknown>();
  return response;
}

export async function getMagiclinkCallback(
  httpClient: HttpClientInstance,
  { token }: { token: string },
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`auth/email/callback`, {
      signal,
      searchParams: buildSearchParams({ token }),
    })
    .json<unknown>();
  return response;
}

export async function postPortalLogin(
  httpClient: HttpClientInstance,
  data: CandidateauthAuthRequest,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`auth/portal/login`, { signal, json: data })
    .json<unknown>();
  return response;
}

export async function postXLogin(
  httpClient: HttpClientInstance,
  data: CandidateauthTestLoginRequest,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`auth/x`, { signal, json: data })
    .json<unknown>();
  return response;
}

export async function postProviderRedirect(
  httpClient: HttpClientInstance,
  provider: "github" | "linkedin",
  data: CandidateauthAuthRequest,
  error?: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`auth/${provider}`, {
      signal,
      json: data,
      searchParams: buildSearchParams({ error }),
    })
    .json<CandidateauthInitializeAuthUrl>();
  return response;
}

export async function getProviderCallback(
  httpClient: HttpClientInstance,
  provider: "github" | "linkedin",
  { state, error }: { state: string; error?: string },
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`auth/${provider}/callback`, {
      signal,
      searchParams: buildSearchParams({ state, error }),
    })
    .json<unknown>();
  return response;
}

export async function postCandidateLogout(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`jobopenings/${job_opening_slug}/auth/logout`, { signal })
    .json<unknown>();
  return response;
}

export async function getCandidatesMe(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`jobopenings/${job_opening_slug}/candidates/me`, { signal })
    .json<CandidateMeResponse>();
  return response;
}

export async function patchCandidateMe(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  data: Partial<CandidateUpdateCandidateParams>,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .patch(`jobopenings/${job_opening_slug}/candidates/me`, {
      signal,
      json: data,
    })
    .json<CandidateMeResponse>();
  return response;
}
